import React from 'react';
import { Card } from '@/components/ui/card';

export default function SettingsCard({ className = '', children, ...props }) {
  return (
    <Card className={`overflow-hidden ${className}`} {...props}>
      {children}
    </Card>
  );
}